function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "Companies_svg__19_a",
  x1: "0%",
  x2: "100%",
  y1: "0%",
  y2: "100%"
}, React.createElement("stop", {
  offset: "0%",
  stopColor: "#F5FBFF"
}), React.createElement("stop", {
  offset: "100%",
  stopColor: "#E8F1FC"
})), React.createElement("linearGradient", {
  id: "Companies_svg__20_b",
  x1: "50%",
  x2: "50%",
  y1: "0%",
  y2: "100%"
}, React.createElement("stop", {
  offset: "0%",
  stopColor: "#62BBF8",
  stopOpacity: 0.2
}), React.createElement("stop", {
  offset: "100%",
  stopColor: "#3386EE",
  stopOpacity: 0.2
})), React.createElement("linearGradient", {
  id: "Companies_svg__21_c",
  x1: "0%",
  x2: "100%",
  y1: "0%",
  y2: "100%"
}, React.createElement("stop", {
  offset: "0%",
  stopColor: "#4DB1FD"
}), React.createElement("stop", {
  offset: "100%",
  stopColor: "#148CFC"
})));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  fill: "url(#Companies_svg__19_a)",
  stroke: "url(#Companies_svg__20_b)",
  d: "M8 .5A7.5 7.5 0 00.5 8v34A7.5 7.5 0 008 49.5h34a7.5 7.5 0 007.5-7.5V8A7.5 7.5 0 0042 .5H8z"
}), React.createElement("path", {
  fill: "url(#Companies_svg__21_c)",
  d: "M20 20.5V16a2 2 0 012-2h6a2 2 0 012 2v10h4a2 2 0 012 2v7a1 1 0 01-1 1h-1v-3.5a.5.5 0 00-.5-.5h-1a.5.5 0 00-.5.5V36h-4v-3a1 1 0 00-1-1h-4a1 1 0 00-1 1v3h-7a1 1 0 01-1-1V23.562a2 2 0 011.515-1.94L20 20.5zm2.5 7.5a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h1a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-1zm0-4a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h1a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-1zm0-4a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h1a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-1zm0-4a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h1a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-1zm4 0a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h1a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-1zm0 12a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h1a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-1zm0-4a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h1a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-1zm0-4a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h1a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-1zm6 8a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h1a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-1zm-16 4a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h1a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-1zm0-4a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h1a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-1zm0-4a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h1a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-1z"
}));

var SvgCompanies = function SvgCompanies(props) {
  return React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50"
  }, props), _ref, _ref2);
};

export default SvgCompanies;